const noopAction: any = {
   publishCounterMonitor: () => noopAction,
   publishDurationMonitor: () => noopAction,
   publishStringMonitor: () => noopAction,
   publish: () => {},
   newChildActionPublisherForMethod: (..._args: any[]) => noopAction,
   newChildActionPublisherForInitialization: (..._args: any[]) => noopAction,
   withMonitor: () => noopAction,
};

const initialMetricsPublisher = {
   newChildActionPublisherForMethod: (..._args: any[]) => noopAction,
   newChildActionPublisherForInitialization: (..._args: any[]) => noopAction,
   publishCounterMonitor: () => noopAction,
   publishDurationMonitor: () => noopAction,
   publishStringMonitor: () => noopAction,
   publish: () => {},
};

export default initialMetricsPublisher;
